/* Orders pagination
 ========================================================================== */
export default function setPagination(container, callback) {
    const section = document.querySelector(container);
    if (section === null) {
        return;
    }
    const pagination = section.querySelector('.c-pagination');
    const links = pagination.querySelectorAll('a');
    // Each link generates an XHR refresh
    links.forEach((link) => {
        link.addEventListener('click', async (event) => {
            event.preventDefault();
            event.stopPropagation();
            const response = await fetch(link.href);
            const html = await response.text();
            section.outerHTML = html;
            callback();
            return false;
        });
    });
}
export function setScrollButton(container, callback) {
    const section = document.querySelector(container);
    if (section === null) {
        return;
    }
    const button = section.querySelector('button.js-btn-paginate');
    if (button === null) {
        return;
    }
    button.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();
        button.setAttribute('disabled', 'disabled');
        const url = `${button.dataset.url}?page=${button.dataset.page}`;
        const response = await fetch(url);
        const html = await response.text();
        // add items to list
        const itemList = section.querySelector('ul');
        itemList.innerHTML += html;
        const page = Number(button.dataset.page);
        const maxPage = Number(button.dataset.maxPage);
        // increment button page or remove it
        if (page >= maxPage) {
            button.style.display = 'none';
        }
        else {
            button.dataset.page = (page + 1).toString();
        }
        button.removeAttribute('disabled');
        // callback on new items
        callback();
    });
}
